export default __webpack_public_path__ + "static/hero_mini_2-d24483f81d953768ff13c6e1f6f62995.jpg";